export default __webpack_public_path__ + "static/media/lunch3.0ad7af34.png";